import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Link } from 'react-router-dom';

export const BrandStatement = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="about"
      ref={ref}
      data-testid="brand-statement-section"
      className="section-padding bg-[#D9CFC0]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="order-2 lg:order-1"
          >
            <div className="image-hover-scale aspect-[4/5] bg-[#C4B6A4]">
              <img
                src="https://customer-assets.emergentagent.com/job_design-intent/artifacts/tk9l919f_Our_Philisophy.jfif"
                alt="Crafted interior detail"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="order-1 lg:order-2"
          >
            <span className="overline text-[#B5703A] block mb-6">Our Philosophy</span>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light text-[#2A2A2A] tracking-tight mb-8">
              Craftsmanship,<br />
              In Every Detail
            </h2>

            <div className="space-y-6 text-[#3D3D3D] font-light leading-relaxed">
              <p>
                At Livingcraftsmen, we approach interiors as a craft—not a service.
              </p>
              <p>
                Every space we design is shaped by material, proportion, and purpose.
                From concept to execution, our focus remains constant: to create spaces
                that feel considered, functional, and enduring.
              </p>
            </div>

            <Link
              to="/portfolio"
              className="btn-secondary inline-flex items-center gap-2 mt-10"
              data-testid="brand-cta"
            >
              Explore Work
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BrandStatement;
